/**
 * Pusher の private チャンネル購読に必要な設定（純粋関数・テスト対象）
 *
 * 背景（2026-09-14）: 予約更新は公開チャンネル 'dispatch-updates' に流れており、
 * app key（公開値）とチャンネル名だけで誰でも購読できた。private 化して、
 * ログイン済みスタッフ（Sanctum トークン保持者）だけが購読できるようにする。
 *
 * - 認証エンドポイントは自社の sys/public/pusher_auth.php（店舗の公開サイトオリジン配下）。
 *   受け取った Bearer トークンで backend の /api/auth/me を呼び、200 のときだけ署名を返す。
 * - backend（別会社管理）側は DispatchEvent の配信先を PrivateChannel にする 1 行だけ。
 *   正: booking-platform/md/handoff-pusher-private-channels.md
 * - 移行期間は public / private の両方を購読し、backend 切替（2026-09-15）後に public を外した。
 */

export const DISPATCH_CHANNEL_PUBLIC = 'dispatch-updates';
export const DISPATCH_CHANNEL_PRIVATE = 'private-dispatch-updates';
export const LINE_CHANNEL_PUBLIC = 'line-chat';
export const LINE_CHANNEL_PRIVATE = 'private-line-chat';

/**
 * 購読するチャンネル。2026-09-15 に backend（那覇・宮古）の PrivateChannel 化と sys/line の切替が
 * 完了したため private のみ。public 名は履歴・診断用に残す（購読しない）。
 */
export const dispatchChannelNames = (): string[] => [DISPATCH_CHANNEL_PRIVATE];
export const lineChannelNames = (): string[] => [LINE_CHANNEL_PRIVATE];

/** 認証エンドポイント URL（店舗の公開サイト配下の /sys/pusher_auth.php） */
export const pusherAuthEndpoint = (siteOrigin: string): string =>
  `${siteOrigin.replace(/\/+$/, '')}/sys/pusher_auth.php`;

/**
 * pusher-js v8 の channelAuthorization オプションを組み立てる。
 * トークンが無い（未ログイン）ときは null = private チャンネルは購読できない。
 */
export function buildChannelAuthorization(siteOrigin: string, token: string | null) {
  if (!token) return null;
  return {
    transport: 'ajax' as const,
    endpoint: pusherAuthEndpoint(siteOrigin),
    headers: { Authorization: `Bearer ${token}` },
  };
}

/** private チャンネルか（subscription_error の扱いを分けるため） */
export const isPrivateChannel = (name: string): boolean => name.startsWith('private-');
